import { render } from "./SignInPage.vue?vue&type=template&id=b58a624c&scoped=true"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"

import "./SignInPage.vue?vue&type=style&index=0&id=b58a624c&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58a624c"]])

export default __exports__